import React from 'react'
import PropTypes from 'prop-types'

import { Table } from 'semantic-ui-react'

import TableHeaderCell from 'Components/TableHeaderCell'

const UsersTableHeader = props => {
  const { handleSort, sortBy, sortOrder } = props

  return (
    <Table.Header>
      <Table.Row>
        <TableHeaderCell handleSort={handleSort} icon="mail" id="email" sortOrder={sortOrder} sorting={sortBy === 'email'} text="Email" />

        <TableHeaderCell
          handleSort={handleSort}
          icon="tag"
          id="firstName"
          sortOrder={sortOrder}
          sorting={sortBy === 'firstName'}
          text="First Name"
        />

        <TableHeaderCell
          handleSort={handleSort}
          icon="tag"
          id="lastName"
          sortOrder={sortOrder}
          sorting={sortBy === 'lastName'}
          text="Last Name"
        />

        <TableHeaderCell icon="address book" text="Groups" disabled />

        <TableHeaderCell
          handleSort={handleSort}
          icon="calendar"
          id="lastLogin"
          sortOrder={sortOrder}
          sorting={sortBy === 'lastLogin'}
          text="Last Login"
        />
      </Table.Row>
    </Table.Header>
  )
}

UsersTableHeader.propTypes = {
  handleSort: PropTypes.func,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
}

export default UsersTableHeader
